export default __webpack_public_path__ + "static/media/tempo-header-1.e6ab6d72.png";